export default {
	title: "",
	subtitle: "List Subscription Invoices",
  path: "subscription_invoices_list",
  paragraph: 'With this endpoint, you can retrieve a list of all invoices associated with a specific subscription by providing its unique ID.',
  request: {
    method: "GET",
		endpoint: "/subscriptions/:id/invoices",
		responses: {
      "data": [
        {
          "charge_at": "2025-10-19",
          "cycle_number": 2,
          "due_at": "2025-10-19",
          "first_charge": false,
          "id": "3799a7a0-392f-4368-80e7-1545cff0509d",
          "inserted_at": "2025-09-19T16:26:13.989090",
          "paid_at": null,
          "retry_attempts": 0,
          "status": "pending",
          "transaction_id": null,
          "updated_at": "2025-09-19T16:26:13.989095",
          "value": "100"
        },
        {
          "charge_at": "2025-09-19",
          "cycle_number": 1,
          "due_at": "2025-09-19",
          "first_charge": true,
          "id": "016685f9-3913-4f32-8963-8b6625ead91a",
          "inserted_at": "2025-09-19T16:26:13.928480",
          "paid_at": "2025-09-19T16:26:13.986621Z",
          "retry_attempts": 0,
          "status": "paid",
          "transaction_id": "33b29f54-96cc-49cf-82bc-d77d443f261b",
          "updated_at": "2025-09-19T16:26:13.986692",
          "value": "100"
        }
      ]
    }
	},
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Subscription/SubscriptionInvoicesList.js